import { PrimitiveBlueprint } from "../types";
import { AVATAR_SIZE_CLASSES } from "./sizeClasses";
import { PRIMITIVE_COLORS } from "../../constants";

const SLIME_COLORS = {
  body: PRIMITIVE_COLORS.green,
  highlight: PRIMITIVE_COLORS.lightGreen,
  border: PRIMITIVE_COLORS.darkSlate,
  eye: PRIMITIVE_COLORS.white,
  pupil: PRIMITIVE_COLORS.darkSlate,
  shadow: PRIMITIVE_COLORS.darkSlate,
};

export const SLIME_BLUEPRINT: PrimitiveBlueprint = {
  id: "slime",
  designSize: AVATAR_SIZE_CLASSES.MEDIUM,
  parts: [
    {
      id: "shadow",
      type: "ellipse",
      bounds: { x: 0.15, y: 0.85, w: 0.7, h: 0.2 },
      style: { fill: SLIME_COLORS.shadow, fillAlpha: 0.3 },
      z: 0,
    },
    {
      id: "body",
      type: "ellipse",
      bounds: { x: 0.15, y: 0.2, w: 0.7, h: 0.65 },
      style: {
        fill: SLIME_COLORS.body,
        stroke: SLIME_COLORS.border,
        strokeWidth: 2,
      },
      z: 1,
    },
    {
      id: "highlight",
      type: "ellipse",
      bounds: { x: 0.25, y: 0.3, w: 0.3, h: 0.25 },
      style: { fill: SLIME_COLORS.highlight, fillAlpha: 0.4 },
      z: 2,
    },
    {
      id: "eye-left",
      type: "ellipse",
      bounds: { x: 0.35, y: 0.45, w: 0.12, h: 0.12 },
      style: {
        fill: SLIME_COLORS.eye,
        stroke: SLIME_COLORS.border,
        strokeWidth: 1.5,
      },
      z: 3,
    },
    {
      id: "eye-right",
      type: "ellipse",
      bounds: { x: 0.53, y: 0.45, w: 0.12, h: 0.12 },
      style: {
        fill: SLIME_COLORS.eye,
        stroke: SLIME_COLORS.border,
        strokeWidth: 1.5,
      },
      z: 3,
    },
    {
      id: "pupil-left",
      type: "ellipse",
      bounds: { x: 0.37, y: 0.47, w: 0.08, h: 0.08 },
      style: { fill: SLIME_COLORS.pupil },
      z: 4,
    },
    {
      id: "pupil-right",
      type: "ellipse",
      bounds: { x: 0.55, y: 0.47, w: 0.08, h: 0.08 },
      style: { fill: SLIME_COLORS.pupil },
      z: 4,
    },
    {
      id: "drip-1",
      type: "ellipse",
      bounds: { x: 0.2, y: 0.75, w: 0.15, h: 0.1 },
      style: {
        fill: SLIME_COLORS.body,
        stroke: SLIME_COLORS.border,
        strokeWidth: 1.5,
      },
      z: 2,
    },
    {
      id: "drip-2",
      type: "ellipse",
      bounds: { x: 0.65, y: 0.78, w: 0.12, h: 0.08 },
      style: {
        fill: SLIME_COLORS.body,
        stroke: SLIME_COLORS.border,
        strokeWidth: 1.5,
      },
      z: 2,
    },
  ],
};
